import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AssessmentOverview from './components/AssessmentOverview';
import AssessmentSurveyDetails from './components/AssessmentSurveyDetails';
import Lost from 'areas/404/components';

function AssessmentRouter() {
  return (
    <Routes>
      <Route path="/" element={<AssessmentOverview />} />
      <Route path="list" element={<AssessmentOverview />} />
      <Route path=":id" element={<AssessmentSurveyDetails />} />
      <Route path="*" element={<Lost />} />
    </Routes>
  );
}

export default AssessmentRouter;
